var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('pages.transfers.title')))]),_vm._v(" "),_c('v-card-text',[_c('wallet')],1),_vm._v(" "),_c('transfer-table',{attrs:{"page":_vm.page},on:{"filterUpdated":function (data) { return _vm.onFilterUpdated(data); }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59045edc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Transfers.vue
// module id = null
// module chunks = 